export class UserInfo {}
//# sourceMappingURL=user-info.js.map
